<section class="hint-banner" role="note" aria-live="polite">
	<div class="icon-box" aria-hidden="true">
		<mat-icon>{{ icon() }}</mat-icon>
	</div>

	<div class="content">
		@if (title()) {
			<p class="title">{{ title() }}</p>
		}
		@if (message()) {
			<p class="message">{{ message() }}</p>
		}
		<ng-content />
	</div>
</section>
